<template>
  <div class="row">
    <div class="col-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2">
      <basic-portlet title="People">
        <template #portlet_actions>
          <button class="btn btn-ss-standout btn-icon-sm" @click="toggleCreateModal">
            <i class="la la-plus" /> New Person
          </button>
        </template>
        <div v-if="all_available_people.length" class="row mt-4">
          <div v-for="person in all_available_people" :key="person.uuid" class="col-6 col-sm-6 col-md-4 col-lg-3 mb-4 text-center">
            <person-card :person="person" :is-index="true" />
          </div>
        </div>
        <div v-else>
          <h5 class="empty-content-margin text-center">
            You have not created any people yet. Click the '+ Person' button above to create your first person.
          </h5>
        </div>
      </basic-portlet>
      <person-create-modal name="person_create_modal" />
      <person-edit-modal name="person_edit_modal" />
      <delete-confirm-modal name="delete-person-confirm" :entities-to-delete="[person]" entity-type="person">
        <p>You are about to delete '{{ person.name }}'</p>
        <p v-if="person.feeds?.length || person.items?.length">
          <span>This person is attached to:</span>
          <span v-if="person.feeds?.length"><br>{{ person.feeds.length }} {{ person.feeds.length === 1 ? 'Podcast' : 'Podcasts' }}</span>
          <span v-if="person.items?.length"><br>{{ person.items.length }} {{ person.items.length === 1 ? 'Episode' : 'Episodes' }}</span>
        </p>
      </delete-confirm-modal>
    </div>
  </div>
</template>

<script>

import PersonCreateModal from "VueModals/PersonCreateModal";
import PersonEditModal from "VueModals/PersonEditModal";
import { usePeopleStore } from "VueStore/app/people";
import PersonCard from "VuePartials/People/PersonCard";
import { mapActions, mapWritableState } from 'pinia';
import DeleteConfirmModal from "VueModals/DeleteConfirmModal";

export default {
  components: {
    DeleteConfirmModal,
    PersonCreateModal,
    PersonEditModal,
    PersonCard,
  },
  data() {
    return {
      people: window.people,
    };
  },
  computed: {
    ...mapWritableState(usePeopleStore, ['all_available_people']),
    ...mapWritableState(usePeopleStore, ['taxonomy']),
    ...mapWritableState(usePeopleStore, ['selected_taxonomy']),
    ...mapWritableState(usePeopleStore, ['person']),
  },
  beforeMount() {
    this.all_available_people = window.people;
  },
  mounted() {
    this.getTaxonomy();

    EventBus.$on('delete-selected-person', (payload) => {
      this.setPerson(payload);
      this.toggleDeleteModal();
    });

    EventBus.$on('new-person-created', () => {
      this.getAllPeople();
    });

    EventBus.$on('person-updated', () => {
      this.getAllPeople();
    });
  },
  methods: {
    ...mapActions(usePeopleStore, ['getAllPeople']),
    ...mapActions(usePeopleStore, ['getTaxonomy']),
    ...mapActions(usePeopleStore, ['setupPersonCreate']),
    ...mapActions(usePeopleStore, ['setPerson']),
    async toggleCreateModal() {
      this.setupPersonCreate();
      this.fireModal('person_create_modal');
    },
    async toggleDeleteModal() {
      const response = await this.fireModal(`delete-person-confirm`);
      if (!response.data.confirm) {
        return false;
      }

      try {
        const response = await axios.delete(`/api/v1/people/${this.person.uuid}`);
        if (response.data.data) {
          toastr.success('Person Deleted.');
          this.getAllPeople();
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
  },
};
</script>
